import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    /**
     * Filter bar styles
     */
    toolbar: {
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(1),
      },
      [theme.breakpoints.up("md")]: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(1, 2),

        flexWrap: "wrap",

        "& > * + *": {
          marginLeft: theme.spacing(2),
        },
      },
    },
    filterWrap: {
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(2, 0),
      },
      [theme.breakpoints.up("md")]: {
        width: 200,
      },
    },
    vehicleFilterWrap: {
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(2, 0),
      },
      /**
       * Have vehicle filter take up remaining space in toolbar. This allows more
       * items to be shown as selected at once
       */
      [theme.breakpoints.up("md")]: {
        flex: 1,
      },
    },
    /**
     * Modal wrapper for filters shown on tablet/mobile only
     */
    popup: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 99,
      padding: theme.spacing(2, 1, 1, 1),
      backgroundColor: theme.palette.grey[100],
    },
    popupClose: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
    },
  })
);
